const CHAT_RESET_MESSAGE = '/reset';
const CHAT_CLEAR_MESSAGE = '/clear';
const CHAT_NEW_MESSAGE = '/new';
const CHAT_INCLUDE_MESSAGE = '/include';
const CHAT_BASE_COMMANDS = [CHAT_RESET_MESSAGE, CHAT_CLEAR_MESSAGE, CHAT_NEW_MESSAGE];
const LOADING_TRANSITION_DURATION = 7500;
const DOCUMENTATION_SOURCE_TYPES = {
  HANDBOOK: {
    value: 'handbook'
  },
  DOC: {
    value: 'doc'
  },
  BLOG: {
    value: 'blog'
  }
};
const MESSAGE_MODEL_ROLES = {
  user: 'user',
  system: 'system',
  assistant: 'assistant',
  agent: 'agent',
  tool: 'tool',
  request: 'request',
  workflow_end: 'workflow_end'
};
const SELECTED_CONTEXT_ITEMS_DEFAULT_COLLAPSED = true;

// TODO this should be a shared util in GitLab UI
const badgeTypes = ['experiment', 'beta', null];
const badgeTypeValidator = value => badgeTypes.includes(value);

// This value of 16384 is based on the value hardcoded in IDE. This is currently hard limit from the backend.
// https://gitlab.com/gitlab-org/editor-extensions/gitlab-lsp/-/blob/main/packages/webview_duo_workflow_panel/src/app/pages/new/components/duo_workflow_prompt.vue?ref_type=heads#L135
const MAX_PROMPT_LENGTH = 16384;
const PROMPT_LENGTH_WARNING = MAX_PROMPT_LENGTH - 100;

export { CHAT_BASE_COMMANDS, CHAT_CLEAR_MESSAGE, CHAT_INCLUDE_MESSAGE, CHAT_NEW_MESSAGE, CHAT_RESET_MESSAGE, DOCUMENTATION_SOURCE_TYPES, LOADING_TRANSITION_DURATION, MAX_PROMPT_LENGTH, MESSAGE_MODEL_ROLES, PROMPT_LENGTH_WARNING, SELECTED_CONTEXT_ITEMS_DEFAULT_COLLAPSED, badgeTypeValidator, badgeTypes };
